const pubsub = window.DR.pubsub;

const utils = require('./utils.js');

/**
 * Creates dark overlay over the whole page for e. g. modal popup window (popIn)
 *
 * @param o the popup
 */
function popOverlay(o) {
  const overlay = ($('#ender-overlay-mask').length) ? $('#ender-overlay-mask')
    : $('<div id="ender-overlay-mask"></div>').appendTo('body');
  const posOrigin = document.body.scrollTop;

  function popClose(popup) {
    overlay.remove();
    popup.hide();
    if (utils.viewport().width < 600) {
      $('#page').show();
      window.scrollTo(0, posOrigin);
    }
    $(document).unbind('keydown');
  }

  if (utils.viewport().width < 600) {
    $('#page').hide();
    window.scrollTo(0, 1);
  }

  $(document).bind('keydown', (e) => {
    if (e.keyCode === 27) {
      popClose(o);
    }
  });

  overlay
    .css({
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: '#000',
      zIndex: '9998',
      opacity: '.5'
    })
    .click(() => {
      popClose(o);
    });

  $('.popInContainer').hide();

  o.appendTo('body');

  function checkPos() {
    let pos = 'fixed';
    if (utils.viewport().width < 600 || (o.height() + 46) > utils.viewport().height) {
      pos = 'absolute';
      window.scrollTo(0, 92);
    }
    return pos;
  }

  o
    .css({
      position: checkPos(),
      top: '40px',
      left: '50%',
      marginLeft: `-${o.width() / 2}px`,
      zIndex: '9999',
      display: 'block'
    })
    .find('.close').on('click', (e) => {
      e.preventDefault();
      popClose(o);
    });

  pubsub.on('resize', (dims) => {
    if (dims.width < 600) {
      o.css({ position: 'absolute' });
    } else {
      o.css({ position: checkPos(), marginLeft: `-${o.width() / 2}` });
    }
  });

}

module.exports = {
  createPopOverlay: function(o) {
    popOverlay(o);
  }
};
